<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <ControlTextField
        v-model="textValue"
        prepend-icon="event"
        v-bind="$attrs"
        :label="label + ` (${_getBrowserTimezone({ format: 'long' })})`"
        :clearable="false"
        readonly
        v-on="on"
      />
    </template>
    <v-date-picker
      v-on="$listeners"
      :value="value"
      @input="(val) => onInput(val)"
      :min="min"
      :max="max"
    />
  </v-menu>
</template>

<script>
import ControlTextField from './ControlTextField'
import mixinAssetHelper from '../../mixins/mixinAssetHelper'
export default {
  inheritAttrs: false,
  components: {
    ControlTextField,
  },
  mixins: [mixinAssetHelper],
  props: ['value', 'min', 'max', 'label'],
  data: () => ({
    menu: false,
    textValue: null,
  }),
  watch: {
    value() {
      this.textValue = this.value
    },
  },
  methods: {
    onInput(val) {
      this.$emit('input', val)
      this.menu = false
    },
  },
}
</script>
